export default function Owner(props) {
  return (
    <div className="owner">
      <p className="owner-name">{props.user}</p>
    </div>
  );
}
